import { fetchWrapper } from '../../helpers';

const BASE_URL = `${process.env.REACT_APP_API_URL}/sdk-config/platforms`;

export const getPlatforms = async () => {
    const res = await fetchWrapper.get(BASE_URL);
    return res.data;
};

export const getPlatform = async (platformId) => {
    const res = await fetchWrapper.get(`${BASE_URL}/${platformId}`);
    return res.data;
};
